import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { resolveAcceptLanguageHeader } from '@app/core/i18n/i18n-storage';

@Injectable()
export class LanguageInterceptor {
  addLanguage(req: HttpRequest<unknown>): HttpRequest<unknown> {
    return req.clone({
      headers: req.headers.set('Accept-Language', resolveAcceptLanguageHeader()),
    });
  }
}
